// ClientsShowTabs' read (finance-real, the user 2026-10-23): each status tab's count, from the open tab's read.
import { useJobClients } from "../../hooks/useAgencyTabs";
import type { JobClientsShow } from "../../types";

export function useClientsShowTabs(show: JobClientsShow): Record<JobClientsShow, number> | undefined {
  return useJobClients(show).data?.counts;
}
